export default {
  SET_CERTS(state, certs) {
    state.certs = certs;
  },

  SET_CERTS_LIST(state, certsList) {
    state.certsList = certsList;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  ADD_CERT(state, cert) {
    state.certs.collection.unshift(cert);
  },

  DELETE_CERT(state, id) {
    const index = state.certs.collection.findIndex((cert) => cert.id === id);
    if (index >= 0) {
      state.certs.collection.splice(index, 1);
    }
  },

  SET_PAGINATOR(state, { page, size, total }) {
    state.paginator.page = page;
    state.paginator.size = size;
    state.paginator.total = total;
  },

  SET_PAGINATOR_PAGE(state, value) {
    state.paginator.page = value;
  },

  SET_PAGINATOR_LOADING_PAGE(state, value) {
    state.paginator.loadingPage = value;
  },

  SET_SORT(state, sort) {
    state.sort = sort;
  },
};
